module.exports = __webpack_public_path__ + "img/rcn.92507243.svg";